import { retryObjectRequest } from './object-request';

/** Join the adoption's existing job. A failed partial preload gets one shared retry. */
export async function joinAdoptionWarmup<K, T>(jobs: { get(key: K): Promise<T> | undefined; delete(key: K): boolean }, key: K, start: () => void,
    options: { throwOnFailure?: boolean } = {}): Promise<boolean> {
    let failure: unknown;
    for (let attempt = 0; attempt < 2; attempt++) {
        start();
        const job = jobs.get(key);
        if (!job) return true;
        try { await job; return true; }
        catch (error) {
            failure = error;
            if (jobs.get(key) === job) jobs.delete(key);
            if (attempt === 0) retryObjectRequest(error);
        }
    }
    if (options.throwOnFailure) throw failure;
    return false;
}
